export const oneHourDeltaValidator = function (timeDelta) {
  return timeDelta[0] !== timeDelta[1]
}
